import cookie from 'vue-cookie';

export default {
	status: '',
	token:
		cookie.get('admtoken', {
			host: window.location.host,
		}) !== null
			? cookie.get('admtoken', {
				host: window.location.host,
			})
			: '',
	logUser: '',
	user: {},
	barstatus:
		localStorage.getItem('barstatus') !== null
			? JSON.parse(localStorage.getItem('barstatus').toLowerCase())
			: true,
	rota: '',
	modaldata: {},
	globalRange: null,
	database: {},
	modalpessoa: false,
	modalPagamento: false,
	modalCondPagamento: false,
	modalAddTabVendas: false,
	modalEditTabVendas: false,
	pedidoEditModalPagamento: false,
	pedidoDataDetail: [],
	updateAdmUserTable: false,
};
